<template>
  <div>
    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg><!---->
      </div>
    </div>
    <form>
      <p class="text-danger" v-show="errors.has('error')">
          {{ getError('error') }}
        </p>
      <table class="table">
        <thead>
            <tr>
              <th>{{$t('settingTaxes.name')}}</th>
              <th></th>
            </tr>
        </thead>
        <tbody>
          <tr v-for="tax_rate in taxes">
            <input type="hidden" :name="'tax_rate'+tax_rate.id" v-model="tax_rate.id">
            <td><input type="text" 
                        min="0"
                        class="form-control" 
                        :name="'name'+tax_rate.id"
                        v-validate="{required: true}" 
                        v-model="tax_rate.name"> 
                <small class="text-danger" v-if="errors.has(tax_rate.hash_id)">
                  {{ getError(tax_rate.hash_id) }}
                </small>
              </td>
            <td><button class="btn btn-danger btn-icon pull-right" @click.prevent="deleteTax(tax_rate.id)"><i :title="$t('general.remove')" class="ti-close "></i></button></td>
          </tr>
          <template>
            <tr>
              <td></td>
              <td><button title="Add" class="btn btn-icon btn-info pull-right" @click.prevent="addNewTax()"><i class="ti-plus"></i> {{$t('general.add')}} {{$t('settingTaxes.single')}}</button></td>
            </tr>
          </template>
        </tbody>
        <tfoot></tfoot>
      </table>
      <div class="text-center">
        <span class="help-block warning">{{$t('settingTaxes.notice')}} <a href="#" @click.prevent="goToCompany()">{{$t('settingTaxes.notice2')}}</a>.</span>
        <button type="submit" class="btn btn-fill btn-success btn-wd" @click.prevent="validate">{{$t('general.update')}} {{$t('settingTaxes.single')}}</button>
      </div>
    </form>
  </div>
</template>


<script>
  import Vue from 'vue'
  import {Input} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import {mapFields} from 'vee-validate'
  Vue.use(Input)

  export default {
    components: {
      [Input.name]: Input
    },
    props: {
      defaultData: {},
      modeldata: {},
      taxesData: {}
    },
    watch: {
      defaultData (value) {
        this.defaults = value
      },
      modeldata (value) {
        this.model = value
      },
      taxesData (value) {
        this.taxes = value
      }
    },
    data () {
      return {
        model: this.value || this.modeldata,
        defaults: this.value || this.defaultData,
        taxes: this.value || this.taxesData,
        loading: true
      }
    },
    computed: {
      ...mapFields(['title', 'description'])
    },
    created () {
      this.$nextTick(function () { this.loading = false })
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveTax()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          // if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop])
          console.warn(this.errors)
          // }
        }
      },
      goToCompany () {
        this.$emit('setSelectedTab', 'Company Details')
      },
      saveTax () {
        this.$nextTick(function () { this.loading = true })
        var data = {}
        var taxes = this.taxes
        var companyId = this.$session.get('selectedCompany')
        for (var tax in taxes) {
          if (!Number.isInteger(taxes[tax].id) && taxes[tax].id.indexOf('new') === 0) {
            delete taxes[tax].id
          }
          taxes[tax].company_id = companyId
        }
        data.data = JSON.stringify(this.taxes)
        data.token = this.$session.get('token')
        var self = this
        this.apiRequest('/settings/taxes/all', 'PUT', data, function (response) {
          if (response.status === true) {
            self.errors.clear()
            self.$nextTick(function () { self.loading = false })
            swal({'text': 'Taxes saved successfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            for (var taxIdx in response.data) {
              response.data[taxIdx].hash_id = response.data[taxIdx].id
            }
            self.$emit('setTaxes', response.data)
          } else {
            self.$nextTick(function () { self.loading = false })
            self.handleErrors(response.errors)
          }
        })
      },
      addNewTax () {
        var id = 'new_' + Math.floor(Math.random() * 10000)
        let newRow = {
          'hash_id': id,
          'id': id,
          'name': ''
          // 'type': '',
          // 'amount': ''
        }
        this.taxes.push(newRow)
      },
      deleteTax (taxId) {
        let thisTaxIdx = this.getObjectByElemKeyValue('id', taxId, this.taxes)

        // var btnCounter = 3
        var self = this
        swal({
          text: `Are you sure you want to delete this tax?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then((result) => {
          if (result) {
            if (!Number.isInteger(taxId) && taxId.indexOf('new') === 0) {
              this.taxes.splice(thisTaxIdx, 1)
              swal({'text': 'Tax deleted successfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            } else {
              var id = taxId
              var data = {
                id: id,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/settings/taxes/' + id, 'DELETE', data, function (response) {
                console.warn(response)
                if (response.status === true) {
                  var updatedTaxes = self.taxes
                  updatedTaxes.splice(thisTaxIdx, 1)
                  self.$emit('setTaxes', updatedTaxes)
                  swal({'text': 'Tax deleted successfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
                } else {
                  swal({'text': 'Something went wrong, please try again later...', 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
                }
              })
            }
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Tabs/Taxes.vue